// Chrome's page translation (and similar extensions) moves React's text nodes
// into <font> wrappers. When React later updates that text it removes or
// inserts around a node that is no longer a child of the parent it remembers,
// and the DOM throws NotFoundError, crashing the page (facebook/react#11538).
// Skipping those calls keeps React rendering; the translated copy stays as is.
// Imported first in instrumentation-client.ts so it runs before any app code.

export function guardDomAgainstPageTranslation(nodePrototype: Node) {
  const originalRemoveChild = nodePrototype.removeChild;
  nodePrototype.removeChild = function <T extends Node>(this: Node, child: T) {
    if (child.parentNode !== this) {
      return child;
    }
    return originalRemoveChild.call(this, child) as T;
  };

  const originalInsertBefore = nodePrototype.insertBefore;
  nodePrototype.insertBefore = function <T extends Node>(
    this: Node,
    newNode: T,
    referenceNode: Node | null
  ) {
    if (referenceNode && referenceNode.parentNode !== this) {
      return newNode;
    }
    return originalInsertBefore.call(this, newNode, referenceNode) as T;
  };
}

if (typeof Node === "function") {
  guardDomAgainstPageTranslation(Node.prototype);
}
